module.exports = __webpack_public_path__ + "static/media/cancellationPolicy-blue.a8961e58.svg";